export const FETCH_GIFT_SET = 'giftSetPage/FETCH_GIFT_SET';
export const UPDATE_GIFT_SET = 'giftSet/UPDATE';
